var _templateObject;

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { MdPhotoCamera } from 'react-icons/md';
import { CoreButton } from './../../../../core';
import useStore from './../../store';
import { variables } from './../../theme';
import styled from 'styled-components';
var MapButton = styled(CoreButton)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  background-color: ", " !important;\n  box-shadow: 1px 1px 3px #ccc;\n  border-radius: 0 !important;\n  padding: 0;\n  height: 29px;\n  width: 29px;\n  border-top: 1px solid #ddd !important;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05) !important;\n  }\n  .icon {\n    width: 16px;\n    height: 16px;\n  }\n"])), variables.colors.white);
/**
 * Button that captures map canvas and triggers download
 */

var MapCaptureButton = function MapCaptureButton(_ref) {
  var currentMap = _ref.currentMap,
      props = _objectWithoutPropertiesLoose(_ref, ["currentMap"]); // Generic state updates for store.
  // Accepts an object of values to update.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  }); // Whether to handle interactions like mobile device?

  var interactionsMobile = useStore(function (state) {
    return state.interactionsMobile;
  }); // Increment to trigger event tracker for use of map capture button.

  var eventMapCapture = useStore(function (state) {
    return state.eventMapCapture;
  });

  var captureMap = function captureMap() {
    // console.log('captureMap')
    var dataURL = currentMap.getCanvas().toDataURL('image/png');
    var a = document.createElement('a');
    a.href = dataURL;
    a.setAttribute('download', 'cri-explorer-capture.png');
    a.click();
    a.remove();
    setStoreValues({
      eventMapCapture: eventMapCapture + 1
    });
  };

  return /*#__PURE__*/React.createElement(MapButton, {
    color: "none",
    active: true,
    id: "map_capture_button",
    className: clsx("map-capture-btn", "mapboxgl-ctrl-icon"),
    onClick: captureMap,
    label: i18n.translate("UI_MAP_CAPTURE"),
    tooltip: !interactionsMobile ? 'left' : ''
  }, /*#__PURE__*/React.createElement(MdPhotoCamera, {
    className: "icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, i18n.translate("UI_MAP_CAPTURE")));
};

export default MapCaptureButton;